import React, { useState } from 'react';
import { Button, TextInput, Stack, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useNavigate } from '~node_modules/react-router/dist';
import { peep_client } from '~src/api/peep';
import { CreateGroupOptions } from '~src/api/peep/groups';

export default function CreateGroup() {
  const [group_name, setGroupName] = useState<string>('');
  const [alias, setAlias] = useState<string>('');
  const navigate = useNavigate();

  const create_group = async () => {
    const opts: CreateGroupOptions = {
      display_name: group_name,
      user_alias: alias,
    };
    try {
      await peep_client.groups.createGroup(opts);
      navigate('/feed');
    } catch (err) {
      console.log(err);
      notifications.show({
        title: 'Default notification',
        message: 'Do not forget to star Mantine on GitHub! 🌟',
      });
    }
  };

  return (
    <Stack align="stretch" justify="center">
      <Title ta="center" order={3}>
        Create Group
      </Title>
      <TextInput
        label="Group Name"
        description="This is what the group will show up as to other users in the group (and yourself)."
        withAsterisk
        radius="md"
        onChange={(e) => {
          setGroupName(e.target.value);
        }}
      />
      <TextInput
        label="Alias"
        description="This is what you will show up as to other users in the group (and yourself)."
        withAsterisk
        radius="md"
        onChange={(e) => {
          setAlias(e.target.value);
        }}
      />
      <Button disabled={!group_name || !alias} onClick={create_group}>
        Create Group
      </Button>
    </Stack>
  );
}
